import { cn } from "@omni/utils/styles";

type DividerMarginTop = "0" | "1" | "2" | "3" | "4" | "5";

export type DividerProps = {
    className?: string;
    marginTop?: DividerMarginTop;
};

const DividerMarginVariants: Record<DividerMarginTop, string> = {
    "0": "tw:mt-0",
    "1": "tw:mt-1",
    "2": "tw:mt-2",
    "3": "tw:mt-3",
    "4": "tw:mt-4",
    "5": "tw:mt-5"
};

export const Divider = ({ className = "", marginTop = "3" }: DividerProps) => (
    <div className={cn("tw:block tw:w-full", className)}>
        <div
            className={cn(
                "tw:border-b tw:border-b-divider",
                DividerMarginVariants[marginTop]
            )}
        />
    </div>
);
